import React from 'react';

import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/standard-button';
import InfoIcon from '@atlaskit/icon/glyph/info';
import { Box, xcss } from '@atlaskit/primitives';

import { messages } from './i18n';

const CardStyles = xcss({
  display: 'flex',
  flexDirection: 'column',
  padding: 'space.075',
  gap: 'space.100',
});

const JIRA_INTEGRATION_LINK =
  'https://support.atlassian.com/jira-cloud-administration/docs/integrate-bitbucket-with-jira/';

/* eslint @typescript-eslint/ban-types: "warn" */
export const NoJiraAssociationInfoCard: React.FC = () => {
  return (
    <Box xcss={CardStyles}>
      <InfoIcon label="" />
      <FormattedMessage
        {...messages.noJiraMessageText}
        values={{
          link: (
            <Button
              appearance="link"
              href={JIRA_INTEGRATION_LINK}
              spacing="none"
              target="_blank"
            >
              <FormattedMessage {...messages.jiraLink} />
            </Button>
          ),
        }}
      />
    </Box>
  );
};
